import { render, staticRenderFns } from "./batchTicketModel.vue?vue&type=template&id=0f9beeca&scoped=true&"
import script from "./batchTicketModel.vue?vue&type=script&lang=js&"
export * from "./batchTicketModel.vue?vue&type=script&lang=js&"
import style0 from "./batchTicketModel.vue?vue&type=style&index=0&id=0f9beeca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9beeca",
  null
  
)

export default component.exports